import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const FPFormDiv = styled(BaseStyles.Div)`
    margin: 0rem 4rem;
`;

export const FPTitleDiv = styled(BaseStyles.Div)`
    text-align: center;
    width: 100%;
`
export const FPPhraseDiv = styled(BaseStyles.Div)`
    display: flex; 
    align-items: center;
    justify-content: center;
    width: 100%;
`

export const FPTitle = styled.h2`  
    margin: 0;
    padding-bottom: 2.5rem;
    font-size: 2.2rem;
    font-weight: 550;
    display: flex; 
    align-items: center;
    justify-content: center;
`;

export const FPPhrase = styled.p`
    margin: 0;
    width: 100%;
    padding-top: 2.5rem;
    padding-bottom: 7rem;
    font-size: 1.6rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow-wrap: break-word;
`

export const CredentialInputField = styled(BaseStyles.InputField)`
    font-size: 1.5rem;
    height: 3rem;
    width: 100%;
`

export const EmailInputField = styled(CredentialInputField)`
    margin-bottom: 1rem;
`

export const EmailMeButtonDiv = styled(BaseStyles.Div)`
    margin-top: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`

export const ActionButton = styled.button`
    padding: 1.1rem 0.5rem;
    font-size: 1.6rem;
    color: white;
    border-radius: 0.7rem;
    border: none;
    overflow-wrap: break-word;
    cursor: pointer;
`

export const EmailMeButton = styled(ActionButton)`
    background-color: #4267B2;
`

export const LogInButtonDiv = styled(BaseStyles.Div)`
    margin-top: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const LogInButton = styled.button`
    margin: 0;
    padding: 0; 
    background: none!important;
    border: none;
    padding: 0!important;
    color: #069;
    cursor: pointer;
    &:hover{
        color: #00ccff;
    }
`
